import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var Modal = require("components/utility/AltModal");
var ProgressBar = require("components/utility/ProgressBar");
var Spinner = require("components/utility/Spinner");

var ExpandableStudentListSelector = require("components/data/exports/ExpandableStudentListSelector")
var ExpandableStatsSelector = require("components/data/exports/ExpandableStatsSelector")
var ExportsDateSpanSelector = require("components/data/exports/ExportsDateSpanSelector")
var DataExportConfirmation = require("components/data/exports/DataExportConfirmation")
var SchoolOrgSelector = require("components/data/exports/SchoolOrgSelector")
var UserSelectorDispatcher = require("components/data/exports/UserSelectorDispatcher")
var ExportTypeSelector = require("components/data/exports/ExportTypeSelector")

var DataExportMetrics = require("lib/data/DataExportMetrics.js")
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var DataActions = require("lib/actions/DataActions");
var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");

require("data/exports/data_export_modal.scss");

@connect(
    (state, props) => ({
        currentAdmin: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
    }),
    (dispatch, props) => ({
        populateData: () => {
            var loading = 'exports'
            var fetchStudents = function () {
                var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS
                return dispatch(RosterActions.fetchStudents({ embeds, loading }));
            }

            var fetchStudentLists = function () {
                var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS
                return dispatch(RosterActions.fetchStudentLists({ embeds, loading }));
            }

            var fetchAdmins = function () {
                return dispatch(RosterActions.fetchAdmins({
                    filters: { ids: [CurrentUser.get().id] },
                    embeds: ['admin.org_ids'],
                    cache: true,
                    loading
                }))
            }

            return Promise.all([fetchAdmins(), fetchStudentLists(), fetchStudents()])
        },
        createDataExport: (data_export) => {
            return dispatch(DataActions.createDataExport({ data_export }))
        },
    })
)
@providePopulateData()
class DataExportModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);

        this.state = {
            ...this.initTrackAndOrgOps(),
            stageIndex: 0,
            persistentData: this.initPersistentData(props),
        };
    }
    
    ///// HELPERS /////
    
    // selects xsl organization options and track
    // based on the user's role
    initTrackAndOrgOps() {
        if (CurrentUser.isDistrictAdmin()) {
            return {
                track: TRACKS[DISTRICT_ADMIN],
                organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.ADMIN]
            }
        } else if (CurrentUser.isSchoolAdmin()) {
            return {
                track: TRACKS[SCHOOL_ADMIN],
                organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.ADMIN]
            }
        } else {
            return {
                track: TRACKS[TEACHER],
                organizationOptions: DataExportMetrics.CSV_ORGANIZATION_OPTIONS[DataExportMetrics.TEACHER]
            }
        }
    }

    // preloads persistent data based on where
    // user loads the modal on data page
    initPersistentData(props) {
        var { effectiveData } = props
        var newPersistentData = {}

        if (effectiveData) {
            var { subjectType, startDate, endDate, userIDs, studentList } = effectiveData

            if (subjectType) {
                var metric = DataExportMetrics.SUBJECT_TO_EXPORT_METRICS[subjectType]
                if (metric) {
                    newPersistentData['selectedMetricCategory'] = metric
                }
            }

            if (startDate && endDate) {
                newPersistentData['startDate'] = startDate
                newPersistentData['endDate'] = endDate
            }

            if (userIDs) {
                newPersistentData['selectedStudents'] = userIDs
            }

            if (studentList) {
                newPersistentData['selectedStudentLists'] = [parseInt(studentList)]
            }
        }
        return newPersistentData
    }

    resetStageData() {
        this.setState({
            stageIndex: 0,
            persistentData: {},
        })
    }
    renderErrorAlert(text) {
        window.wrNotifications.triggerDropDownNotification({
            text: text,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    skipStage(updatedPersistentData, newStageIndex) {
        // skip date selector when exporting roster data
        if (updatedPersistentData.selectedMetricCategory == DataExportMetrics.ROSTER) {
            return this.state.track[newStageIndex].name == 'date-selector'
        }
    }

    ///// STAGE CONTROLLERS /////
    getStageCount() {
        return this.state.track.length;
    }

    getCurrentStageData() {
        return this.state.track[this.state.stageIndex];
    }

    getStageTitle() {
        var { persistentData } = this.state
        
        var currentStageData = this.getCurrentStageData();
        
        // handle special cases
        if (currentStageData.name == 'student-selector' &&
            persistentData['selectedOrganizationType'] &&
            persistentData['selectedOrganizationType'] == 'per-class') {
            return 'Select Classes'
        }

        if (currentStageData.name == 'user-selector' &&
            persistentData['selectedOrganizationType'] &&
            persistentData['selectedOrganizationType'] == 'per-teacher') {
            return 'Select Teachers'
        }

        return currentStageData.title;
    }

    ///// HANDLERS /////

    handleCloseModal() {
        if (this.props.onComplete) {
            this.props.onComplete()
        }
    }

    // handles next button
    handleAdvanceStage(newPersistentData) {
        var newStageIndex = this.state.stageIndex + 1;
        if (newPersistentData) {
            var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
        } else {
            var updatedPersistentData = this.state.persistentData;
        }

        this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, () => {
            if (this.skipStage(updatedPersistentData, newStageIndex)) {
                this.handleAdvanceStage(updatedPersistentData)
            }
        });
    }

    // handles back button
    handleRetreatStage(newPersistentData) {
        var newStageIndex = this.state.stageIndex - 1;
        
        if (newPersistentData) {
            var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
        } else {
            var updatedPersistentData = this.state.persistentData;
        }
        this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, () => {
            if (this.skipStage(updatedPersistentData, newStageIndex)) {
                this.handleRetreatStage(updatedPersistentData)
            }
        });
    }

    handlePrint() {
        this.props.handlePrint()
    }

    ///// SUBMIT METHOD /////
    onSubmit(email) {
        var { persistentData } = this.state

        if (persistentData.selectedMetricCategory == DataExportMetrics.ADDITIONAL_METRICS) {
            // convert selected metrics to digest embed
            var digestEmbeds = persistentData.selectedMetrics.map(m => {
                // some digets embeds need to be handled differently than
                // they are on the other stats table (i.e. 'zpd-below')
                if (_.includes(_.keys(DIGEST_EMBED_OVERIDES), m)) {
                    return DIGEST_EMBED_OVERIDES[m]
                } else {
                    return StudentMetrics.getDigestEmbeds([m])
                }
            })
        }

        var data_export = {
            email: email,
            organization_type: persistentData.selectedOrganizationType || null,
            date_span: persistentData.selectedDatePeriod || null,
            start_date: persistentData.startDate || null,
            end_date: persistentData.endDate || null,
            metrics_list: digestEmbeds || persistentData.selectedMetrics || null,
            metric_category: persistentData.selectedMetricCategory || null,
            student_ids: persistentData.selectedStudents || null,
            student_list_ids: persistentData.selectedStudentLists || null,
            admin_ids: persistentData.selectedTeachers || null
        }
        
        return this.props.createDataExport(data_export).then(response => {
            if (!response.errors) {
                window.wrNotifications.triggerDropDownNotification({
                    title: "Done!", text: 'Your data export is being generated and will be sent to your email shortly.', icon: "star"
                });
                
                this.handleCloseModal()
            }
        });
    }

    ///// RENDER METHODS /////
    renderContent() {
        if (this.props.loading) {
            return <Spinner placeholder={true} scale={1.7} />
        } else {
            var currentStageData = this.getCurrentStageData();
            return (
                <currentStageData.display
                    {...currentStageData.props}
                    track={this.state.track}
                    persistentData={this.state.persistentData}
                    organizationOptions={this.state.organizationOptions}
                    currentAdmin={this.props.currentAdmin}
                    onSubmit={this.onSubmit}
                    onRetreat={this.handleRetreatStage}
                    onComplete={this.handleAdvanceStage}
                    handlePrint={this.handlePrint} />
            )
        }
    }
    render() {
        return (
            <div className="dataExportModal">
                <div className="dataExportProgressSection">
                    <p className="dataExportTitle">{this.getStageTitle()}</p>
                    <ProgressBar current={this.state.stageIndex} total={this.getStageCount() - 1} />
                </div>
                {this.renderContent()}
            </div>
        );
    }
}

DataExportModal.propTypes = StrictPropTypes({
    onComplete: PropTypes.func,
    effectiveData: PropTypes.object,
    handlePrint: PropTypes.func
});

var DISTRICT_ADMIN = 'districtAdmin'
var SCHOOL_ADMIN = 'schoolAdmin'
var TEACHER = 'teacher'

var TRACKS = {
    [DISTRICT_ADMIN]: [
        {
            name: 'export-type-selector',
            title: 'Select a Report Type',
            display: ExportTypeSelector
        },
        {
            name: 'school-org-selector',
            title: 'Select a School Org',
            display: SchoolOrgSelector
        },
        {
            name: "metric-selector",
            title: "Select Metrics",
            display: ExpandableStatsSelector,
        },
        {
            name: "date-selector",
            title: "Select a Timeframe",
            display: ExportsDateSpanSelector,
        },
        {
            name: "user-selector",
            title: "Select Students",
            display: UserSelectorDispatcher
        },
        {
            name: "confirmation",
            title: "Confirm Your Data Export",
            display: DataExportConfirmation
        }
    ],
    [SCHOOL_ADMIN]: [
        {
            name: 'export-type-selector',
            title: 'Select a Report Type',
            display: ExportTypeSelector
        },
        {
            name: "metric-selector",
            title: "Select Metrics",
            display: ExpandableStatsSelector,
        },
        {
            name: "date-selector",
            title: "Select a Timeframe",
            display: ExportsDateSpanSelector,
        },
        {
            name: "user-selector",
            title: "Select Students",
            display: UserSelectorDispatcher
        },
        {
            name: "confirmation",
            title: "Confirm Your Data Export",
            display: DataExportConfirmation
        }
    ],
    [TEACHER]: [
        {
            name: 'export-type-selector',
            title: 'Select a Report Type',
            display: ExportTypeSelector
        },
        {
            name: "metric-selector",
            title: "Select Metrics",
            display: ExpandableStatsSelector,
        },
        {
            name: "date-selector",
            title: "Select a Timeframe",
            display: ExportsDateSpanSelector,
        },
        {
            name: "student-selector",
            title: "Select Students",
            display: ExpandableStudentListSelector
        },
        {
            name: "confirmation",
            title: "Confirm Your Data Export",
            display: DataExportConfirmation
        }
    ]
};

var DIGEST_EMBED_OVERIDES = {
    'zpd-below': 'zpd_below'
}

module.exports = DataExportModal;


// WEBPACK FOOTER //
// ./modules/components/data/exports/DataExportModal.js